import { render, staticRenderFns } from "./safety_phone.vue?vue&type=template&id=327d02aa&scoped=true"
import script from "./safety_phone.vue?vue&type=script&lang=js"
export * from "./safety_phone.vue?vue&type=script&lang=js"
import style0 from "./safety_phone.vue?vue&type=style&index=0&id=327d02aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327d02aa",
  null
  
)

export default component.exports